import { render, staticRenderFns } from "./ClinicUserManagement.vue?vue&type=template&id=259cc5d2"
import script from "./ClinicUserManagement.vue?vue&type=script&lang=js"
export * from "./ClinicUserManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports